import { motion } from "framer-motion";
import { Overline } from "./Reveal";
import { CAPABILITIES, PROFILE } from "../../data/content";

export const Capabilities = () => (
  <section className="relative overflow-hidden bg-[#0c2c20] py-28 md:py-40">
    <div
      className="pointer-events-none absolute inset-0 opacity-[0.12]"
      style={{
        backgroundImage: `url(${PROFILE.architecture})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    />
    <div className="absolute inset-0 bg-gradient-to-b from-[#0c2c20] via-[#0c2c20]/85 to-[#0c2c20]" />

    <div className="relative mx-auto max-w-[1400px] px-6 md:px-12">
      <Overline>03 — Core Leadership Capabilities</Overline>
      <h2 className="mt-6 max-w-4xl font-display text-4xl font-bold leading-[1.05] text-white sm:text-5xl lg:text-6xl">
        Twenty disciplines. One
        <span className="font-serif-e italic text-[#c9a24e]"> operating standard.</span>
      </h2>

      <div className="mt-16 flex flex-wrap gap-3">
        {CAPABILITIES.map((c, i) => (
          <motion.span
            key={c}
            data-testid={`capability-${i}`}
            initial={{ opacity: 0, scale: 0.94 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: (i % 8) * 0.04 }}
            className="cursor-default border border-white/12 px-5 py-3 text-sm text-[#d4d4d8] transition-colors duration-300 hover:border-[#c9a24e] hover:bg-[#c9a24e] hover:text-black"
          >
            {c}
          </motion.span>
        ))}
      </div>
    </div>
  </section>
);
